export default "__VITE_ASSET__NuoB392R__"